__turbopack_context__.v({
  "root": "checkout-module__omYwwq__root",
  "shippingLabelFadeIn": "checkout-module__omYwwq__shippingLabelFadeIn",
});
